



































































































import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import { IUserProfileUpdate } from '@/interfaces';
import { readUserProfile } from '@/store/main/getters';
import {dispatchUpdateUserAvatar, dispatchUpdateUserProfile} from '@/store/main/actions';
import MdIcon from '../../../components/vui-luma/Ui/MdIcon.vue';
import PageHeader from '../../../components/vui-luma/Ui/PageHeader.vue';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import {FmvInputGroupMerge} from 'fmv-input-group-merge';
import {FmvAvatar} from 'fmv-avatar';

@Component({
  components: {
    MdIcon,
    PageHeader,
    PageSeparator,
    FmvInputGroupMerge,
    FmvAvatar,
  },
})
export default class UserProfileEdit extends Vue {
  public valid = true;
  public fullName: string = '';
  public firstName: string = '';
  public lastName: string = '';
  public email: string = '';
  public containerClass = 'container page__container';

  public created() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      this.firstName = userProfile.first_name;
      this.lastName = userProfile.last_name;
      this.email = userProfile.email;
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }

  public reset() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile) {
      this.firstName = userProfile.first_name;
      this.lastName = userProfile.last_name;
      this.email = userProfile.email;
    }
  }

  public cancel() {
    this.$router.back();
  }

  public async submit() {
    const updatedProfile: IUserProfileUpdate = {};
    if (this.firstName) {
      updatedProfile.first_name = this.firstName;
    }
    if (this.lastName) {
      updatedProfile.last_name = this.lastName;
    }
    if (this.email) {
      updatedProfile.email = this.email;
    }
    await dispatchUpdateUserProfile(this.$store, updatedProfile);
    await this.$router.push('/dashboard');
  }

  public async uploadAvatar(e) {
    const formData = new FormData();
    if (e.target.files[0] !== undefined) {
      formData.append(e.target.name, e.target.files[0]);
    }
    await dispatchUpdateUserAvatar(
      this.$store,
      {
        // @ts-ignore
        data: formData,
      },
    );
  }
}
